module.exports = __webpack_public_path__ + "img/index.ea51268c.png";